module.exports = __webpack_public_path__ + "img/9ad6bd7.svg";